import { TYPES } from "./default_supporter.type";

const initState = {
  defaultSupporterAll: null,
  defaultSupporterOpenAdd: false,
  defaultSupporterOpenEdit: false,
  defaultSupporterSelected: null,
  defaultSupporterSearch: "",
  //
  defaultSupporterInfo: null,
  defaultSupporterType: "email",
};

const defaultSupporterReducer = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case TYPES.SET_DEFAULT_SUPPORTER_TYPE:
      return {
        ...state,
        defaultSupporterType: payload,
      };

    case TYPES.SET_DEFAULT_SUPPORTER_INFO:
      return {
        ...state,
        defaultSupporterInfo: payload,
      };

    case TYPES.SET_DEFAULT_SUPPORTER_ALL:
      return {
        ...state,
        defaultSupporterAll: payload,
      };

    case TYPES.SET_DEFAULT_SUPPORTER_OPEN_ADD:
      return {
        ...state,
        defaultSupporterOpenAdd: payload,
      };

    case TYPES.SET_DEFAULT_SUPPORTER_OPEN_EDIT:
      return {
        ...state,
        defaultSupporterOpenEdit: payload,
      };

    case TYPES.SET_DEFAULT_SUPPORTER_SELECTED:
      return {
        ...state,
        defaultSupporterSelected: payload,
      };

    case TYPES.SET_DEFAULT_SUPPORTER_SEARCH:
      return {
        ...state,
        defaultSupporterSearch: payload,
      };

    default:
      return state;
  }
};

export default defaultSupporterReducer;
